'use es6';

import PropTypes from 'prop-types';
import ReportResolver from 'reporting-ui-components/reports/ReportResolver';
import { Chevron } from 'foundations-components/transitional/components/Chevron';
import { ReportType } from 'reporting-ui-components/types/ReportTypes';
import { Flex } from 'foundations-components/components/Flex';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedPercentage from 'I18n/components/FormattedPercentage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import DeltaDisplay from './DeltaDisplay';
import NoData from 'reporting-ui-components/components/shared/NoData';
import { Text } from 'foundations-components/components/Text';
import { H6 } from 'foundations-components/transitional/components/H6';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PerformanceStage = ({
  report,
  conversionRate,
  count,
  deltaRate,
  title,
  sourcesPath,
  property
}) => {
  const conversionNode = /*#__PURE__*/_jsx(View, {
    paddingInlineEnd: 300,
    children: conversionRate != null ? /*#__PURE__*/_jsx(Chevron, {
      direction: "right",
      children: /*#__PURE__*/_jsx(FormattedPercentage, {
        value: conversionRate * 100,
        precision: 2
      })
    }) : null
  });
  const reportNode = /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    alignItems: "stretch",
    flexGrow: 1,
    blockSize: "100%",
    minBlockSize: 0,
    children: /*#__PURE__*/_jsx(ReportResolver, {
      noDataRenderer: () => /*#__PURE__*/_jsx(NoData, {}),
      report: report
    })
  });
  return /*#__PURE__*/_jsxs(Flex, {
    flexGrow: 1,
    flexBasis: 0,
    blockSize: "100%",
    overflow: "auto",
    flexDirection: "column",
    alignItems: "stretch",
    marginInlineEnd: property !== 'customers' ? 600 : 0,
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexGrow: 0,
      justifyContent: "space-between",
      paddingBlockEnd: 600,
      children: [/*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        flexGrow: 1,
        flexWrap: "nowrap",
        children: [/*#__PURE__*/_jsx(H6, {
          marginBlockEnd: "0",
          children: title
        }), /*#__PURE__*/_jsx(Text, {
          typography: "body-700",
          color: "fill-accent-neutral-default",
          children: /*#__PURE__*/_jsx(Link, {
            use: "unstyled",
            href: sourcesPath,
            children: /*#__PURE__*/_jsx(FormattedNumber, {
              value: count
            })
          })
        }), /*#__PURE__*/_jsx(DeltaDisplay, {
          deltaRate: deltaRate,
          report: report
        })]
      }), conversionNode]
    }), reportNode]
  });
};
PerformanceStage.propTypes = {
  report: ReportType.isRequired,
  conversionRate: PropTypes.number,
  count: PropTypes.number.isRequired,
  deltaRate: PropTypes.number,
  title: PropTypes.string.isRequired,
  sourcesPath: PropTypes.string.isRequired
};
export default PerformanceStage;